import { instance } from '@/services/avik-api-gateway'
import { VehicleTypeGroupPeriod } from '@/types/vehicle-type-group-period'
import { AxiosResponse } from 'axios'

export function createVehicleTypeGroupPeriod(
  body: VehicleTypeGroupPeriod
): Promise<AxiosResponse<VehicleTypeGroupPeriod>> {
  return instance.post(`/vehicle-type-group-period`, body)
}
